"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.galleryTags.name': 'Tag Galleria',
    'tools.galleryTags.description': 'Gestisci e organizza i contenuti della galleria con i tag',
};
